import React, { useEffect, useMemo, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getAllGalleries } from "../../services/gallerieServices";
import { getSettings } from "../../services/settingsServices";

const API_BASE = process.env.REACT_APP_API_URL;
const FALLBACK = "/img/no-image.jpg";

function toAbsolutePhotoUrl(url) {
  const u = (url || "").trim();
  if (!u) return "";

  // déjà absolue
  if (/^https?:\/\//i.test(u)) return u;

  // /uploads/xxx => API_BASE + /uploads/xxx
  if (u.startsWith("/uploads/")) return `${API_BASE}${u}`;

  // uploads/xxx => API_BASE + /uploads/xxx
  if (u.startsWith("uploads/")) return `${API_BASE}/${u}`;

  // autres cas : si c'est un chemin relatif classique
  if (u.startsWith("/")) return `${API_BASE}${u}`;

  return `${API_BASE}/${u}`;
}

const Diaporama = () => {
  const [photos, setPhotos] = useState([]);
  const [carrouselExists, setCarrouselExists] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGalleryPhotos = async () => {
      try {
        const settings = await getSettings();
        const carrouselId = settings?.[0]?.carrousel_id;

        // si pas de carrousel configuré
        if (!carrouselId || Number(carrouselId) === 0) {
          setCarrouselExists(false);
          setPhotos([]);
          return;
        }

        setCarrouselExists(true);

        const galleries = await getAllGalleries();
        const selectedGallery = (galleries || []).find(
          (g) => String(g.id) === String(carrouselId)
        );

        const actives =
          selectedGallery?.photos?.filter(
            (p) => p?.is_active && (p.photo_url || "").trim()
          ) || [];

        setPhotos(actives);
      } catch (error) {
        console.error("Erreur lors de la récupération des photos:", error);
        setPhotos([]);
        setCarrouselExists(false);
      } finally {
        setLoading(false);
      }
    };

    fetchGalleryPhotos();
  }, []);

  const slides = useMemo(() => {
    return (photos || []).map((p) => ({
      id: p.id,
      src: toAbsolutePhotoUrl(p.photo_url) || FALLBACK,
      alt: p.description || `Photo ${p.id}`,
    }));
  }, [photos]);

  if (loading || !carrouselExists) return null;
  if (slides.length === 0) return null;

  return (
    <Carousel
      autoPlay
      infiniteLoop
      useKeyboardArrows
      dynamicHeight
      showThumbs={false}
      interval={5000}
      showStatus={false}
    >
      {slides.map((s) => (
        <div key={s.id}>
          <img
            src={s.src}
            alt={s.alt}
            loading="lazy"
            style={{
              width: "100%",
              height: "auto",
              objectFit: "contain", // ✅ pas coupé
              background: "#0f172a10", // léger fond pour bandes éventuelles
            }}
            onError={(e) => {
              e.currentTarget.src = FALLBACK;
            }}
          />
          {/* <p className="legend">{s.alt}</p> */}
        </div>
      ))}
    </Carousel>
  );
};

export default Diaporama;
